import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchers } from "../fetchers";

const FEEDBACK_KEY = "feedback";

const useFeedbacks = () => {
  return useQuery({
    queryKey: [FEEDBACK_KEY],
    queryFn: fetchers.feedback.getFeedbacks,
  });
};

const useAddFeedback = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [FEEDBACK_KEY],
    mutationFn: fetchers.feedback.addFeedback,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FEEDBACK_KEY] });
    },
  });
};

const useToggleVote = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [FEEDBACK_KEY],
    mutationFn: fetchers.feedback.toggleVote,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [FEEDBACK_KEY] });
    },
  });
};

export const feedbackHooks = {
  useFeedbacks,
  useAddFeedback,
  useToggleVote,
};
